import React, { createContext, useMemo } from "react";
import { useGetSeverityTypes } from "hooks/severity-types/useGetSeverityTypes";
import PropTypes from "prop-types";
import { SeverityType } from "core/enums";
import { useTheme } from "@mui/material/styles";
import severityColors from "assets/jss/default/severityColors";

export const SeverityTypeContext = createContext({
  loading: true,
  error: false,
  severityTypes: [],
  alertSeverityTypes: [],
  ruleSeverityTypes: [],
  count: 0
});
SeverityTypeContext.displayName = "SeverityTypeContext";

export const SeverityTypeProvider = ({ children }) => {
  const { loading, error, severityTypes, count } = useGetSeverityTypes();
  const theme = useTheme();

  const calculatedSeverityTypes = useMemo(() => {
    const rawSeverityColors = severityColors(theme);
    return (
      severityTypes?.map(severityType => {
        const severityColor = rawSeverityColors[severityType.colour];

        severityType.color = severityColor?.color;
        severityType.backgroundColor = severityColor?.backgroundColor;

        return severityType;
      }) ?? []
    );
  }, [severityTypes, theme]);

  // TODO: remove alertSeverityTypes when unassigned has been removed from the severity types table
  // TODO: remove ruleSeverityTypes when severity types have a boolean for if they can be set by a user
  return (
    <SeverityTypeContext.Provider
      value={{
        loading,
        error,
        severityTypes: calculatedSeverityTypes,
        alertSeverityTypes: severityTypes?.filter(
          x => x.id !== SeverityType.UNASSIGNED
        ),
        ruleSeverityTypes: severityTypes?.filter(
          x => x.id !== SeverityType.UNASSIGNED && x.id !== SeverityType.GOOD
        ),
        count
      }}
    >
      {children}
    </SeverityTypeContext.Provider>
  );
};

SeverityTypeProvider.propTypes = {
  children: PropTypes.node
};
